export function validate(company) {
    const {passport, tin, organization, country} = company;
    if (country === "am"){
      if (organization === "LEGAL" && tin && tin.length !== 8){
        return "tinValidationError";
      }
      if (organization === "INDIVIDUAL" && passport && passport.length !== 9){
        return "passportValidationError";
      }
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/company/validator.js